// Texty stránky Hodnotenie obchodu — slovenské dvojča locale/cs/ratingsPage.js.
// Ověřeno v dev/sk/ratings.html: `.itemsTotal` nese „N položiek celkom" a
// `.stars-label` „N hodnotení" (genitiv množného čísla je invariantní jako v CZ).
// Heureka na SK neběží (grep dev/sk/ratings.html bez shody) — text zůstává jako
// SK dvojče, badge se prakticky nevykreslí (viz report workera).

import { plural } from '../plural.js';

export default {
  eyebrow: 'Overené zákazníkmi',
  /** platformy souhrnu SK (manifest SK: Heureka, Google) */
  perex: 'Ako nás hodnotia zákazníci na Heureke, Googli a priamo u nás.',
  platformsTitle: 'Hodnotenie podľa platforiem',
  listTitle: 'Čo o nás píšu zákazníci',
  /** SK nepřebírá hodnocení z Heureky (dev/sk/ratings.html bez heureka bloků) → věta bez Heureky */
  listSub: (n, count, avg) =>
    n + ' '
    + plural(count, ['hodnotenie od zákazníka', 'hodnotenia od zákazníkov', 'hodnotení od zákazníkov'])
    + (avg ? ', priemerne ' + avg + ' z 5.' : '.'),
  filter: 'Filtrovať:',
  all: 'Všetko',
  filterNote: 'Filter pracuje s hodnoteniami na aktuálnej strane výpisu.',
  empty: 'Žiadne hodnotenia v tomto filtri',
  emptyCta: 'Zobraziť všetko',
  customer: 'Zákazník',
  verified: 'Overené Heurekou',
  page: 'Strana ',
  monthDot: '. ',
  prevPage: 'Predchádzajúca strana',
  nextPage: 'Ďalšia strana',
  pagerAria: 'Stránkovanie hodnotení',
  /** counter bez filtru: „Strana 1 z 5 · zobrazené 30 z 2 869 hodnotení" */
  counterAll: (page, pages, shown, total) =>
    'Strana ' + page + ' z ' + pages + ' · zobrazené ' + shown + ' z ' + total + ' hodnotení',
  /** counter s filtrem: „Filter 5★: na tejto strane 12 z 30 hodnotení (celkom 900×)" */
  counterFiltered: (score, shown, total, bucketCount) =>
    'Filter ' + score + '★: na tejto strane ' + shown + ' z ' + total + ' hodnotení'
    + (bucketCount != null ? ' (celkom ' + bucketCount + '×)' : ''),
  /**
   * Sekce „Ako recenzie overujeme": SK ji zatím nemá (`reviews.verifyAnchor`
   * je null, recenze U6), dvojče žije kvůli tvaru. Před zapnutím na SK text
   * schvaluje Tomáš.
   */
  verifyTitle: 'Ako recenzie overujeme',
  verifyHeureka: (label) =>
    'Recenzie označené „' + label + '“ pochádzajú z dotazníka služby Heureka Overené zákazníkmi, ktorý Heureka posiela po nákupe u nás. Hodnotenia preberáme bez úprav textu.',
  verifyWeb: (label) => 'Recenzie označené „' + label + '“ píšu zákazníci priamo na našom webe a nákup pri nich neoverujeme.',
  verifyBuyer: (label) =>
    'Hodnotenia obchodu so štítkom „' + label + '“ napísali zákazníci, ktorí si produkt u nás kúpili (párujeme ich cez číslo objednávky).',
  verifyShop: (label) => 'Hodnotenia so štítkom „' + label + '“ sa týkajú nákupu u nás, nie konkrétneho produktu.',
};
